import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { TRIP_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

export type CreateGeneralSettingsVariables = Array<{
  name: string;
  value: boolean | string;
  type: string;
}>;

type CreateGeneralSettingsJobResult = {
  success: boolean;
  result: {
    fieldCount: number;
    affectedRows: number;
    insertId: number;
    serverStatus: number;
    warningCount: number;
    message: string;
    protocol41: boolean;
    changedRows: number;
  };
};

type QueryError = {};

const useCreateGeneralSettingsMutation = (
  options?: UseMutationOptions<
    CreateGeneralSettingsJobResult,
    QueryError,
    CreateGeneralSettingsVariables
  >
) => {
  const { fetchWithAuth, cancel } = useFetchWithAuth();
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;

  return {
    ...useMutation<
      CreateGeneralSettingsJobResult,
      QueryError,
      CreateGeneralSettingsVariables
    >(
      async (input: CreateGeneralSettingsVariables) => {
        const url = `${TRIP_ENDPOINT}/general-settings/bulk`;
        const inputData = input.map((each) => ({ ...each, tid }));

        return fetchWithAuth<CreateGeneralSettingsJobResult>(url, {
          method: "POST",
          body: inputData,
        });
      },
      {
        ...options,
      }
    ),
    cancel,
  };
};

export default useCreateGeneralSettingsMutation;
